<ion-header>
  <ion-toolbar>
    <ion-title>Filtri</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="onClose()" fill="clear" size="small">
        <span class="material-symbols-outlined">close</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="d-flex ion-justify-content-between ion-align-items-center px-xs safe-area-top">


</div>

<ion-content>

  <div class="content-padding">

    <div *ngFor="let group of params?.filters | keyvalue">

      <div class="app-card-box w-100"
           *ngIf="group.value?.length > 0">
        <div class="ts-body-bold">
          {{('FILTERS.' + group.key) | translate}}
        </div>

        <div *ngFor="let option of group.value">
          <ion-checkbox
            [(ngModel)]="option.checked"
            mode="md"
            labelPlacement="end"
            class="mt-sm">
            {{ option.label }}
          </ion-checkbox>
        </div>
      </div>

    </div>

  </div>

</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="d-flex">
      <ion-button class="secondary w-100"
                  fill="clear"
                  (click)="onResetFiltri()">
        Cancella filtri
      </ion-button>
      <ion-button class="w-100" (click)="onApplyFilter()">
        {{ 'Conferma' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
